<template>
  <v-card outlined tile>
    <RawMaterialsTable :rawmaterials="material.children"/>
  </v-card>
</template>

<script>
import RawMaterialsTable from "../../components/Material/RawMaterialsTable";
export default {
  name: "MaterialRawMaterials",
  components: { RawMaterialsTable },
  props: {
    material: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
};
</script>
